import { useEffect } from 'react';
import { NavLink, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import './AccountSuspended.scss';

export default function AccountSuspended() {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    document.title = t('account_suspended.page_title');
  }, [t]);

  // Only reachable via the app's own subscription-gate redirect (see AuthProvider/Login) —
  // typing the URL directly, bookmarking it, or refreshing lands here with no router state,
  // so it bounces to /login instead of showing freely to anyone.
  if (!location.state?.fromGate) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="account-suspended">
      <img className="account-suspended__logo" src="/images/saydalani_logo.png" alt="Saydalani Logo" />

      <div className="account-suspended__card">
        <div className="account-suspended__icon">
          <FontAwesomeIcon icon={faCircleExclamation} />
        </div>
        <h1>{t('account_suspended.page_title')}</h1>
        <p>
          {t('account_suspended.message')}
        </p>
        <p>{t('account_suspended.contact_prompt')}</p>

        <a href="mailto:contact@saydalani.com" className="account-suspended__contact">
          <FontAwesomeIcon icon={faEnvelope} />
          contact@saydalani.com
        </a>
        <a href="tel:+212609899272" className="account-suspended__contact">
          <FontAwesomeIcon icon={faPhone} />
          +212 6 09 89 92 72
        </a>

        <NavLink to="/login" className="account-suspended__back">
          {t('account_suspended.back_to_login')}
        </NavLink>
      </div>
    </div>
  );
}
